import TrustPilotFooter from "@/components/molecules/trustpilot-footer/trustpilot-footer";

type MedicalConditionsFooterProps = {
  trustpilotImage?: string;
  link?: string;
};

function MedicalConditionsFooter({
  trustpilotImage,
  link,
}: Readonly<MedicalConditionsFooterProps>) {
  if (trustpilotImage && link) {
    return (
      <div className="w-full">
        <TrustPilotFooter trustpilotImage={trustpilotImage} link={link} />
      </div>
    );
  }
  return null;
}

export default MedicalConditionsFooter;
